export default __webpack_public_path__ + "static/media/e_shipped.282385de.png";